import type { KeyboardEvent } from 'react';

/**
 * onKeyDown for a non-<button> element that carries role="button" and tabIndex={0} (WCAG 2.1.1):
 * Enter and Space activate it, like a native button. A key pressed on a control NESTED inside it (its own button,
 * link or field) keeps that control's behaviour, so it is ignored here. Also ignored: a composing Enter (an IME
 * choosing a candidate; Safari reports the Enter that ends composition as keyCode 229 with isComposing false);
 * auto-repeat does not activate again (holding a key activates once) but still has its default prevented, so a held
 * Space cannot scroll the page.
 */
export function activateOnKey(activate?: () => void) {
  return (event: KeyboardEvent<HTMLElement>) => {
    if (event.target !== event.currentTarget) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (event.nativeEvent?.isComposing || event.nativeEvent?.keyCode === 229) return;
    event.preventDefault(); // every keydown, repeats included: a held Space must not scroll the page
    if (!event.repeat) activate?.();
  };
}
